var _rect, _circle, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicsAndTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 507,
    viewBox: "0 0 502 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 507,
    rx: 21,
    fill: "#F3F7FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.663,
    cy: 111.141,
    r: 64.1184,
    fill: "#C89EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.781 111.141C209.781 124.316 205.723 137.17 198.159 147.956C190.594 158.742 179.891 166.937 167.505 171.425C155.119 175.913 141.651 176.476 128.933 173.039C116.215 169.601 104.865 162.33 96.4259 152.213C87.9869 142.097 82.869 129.626 81.7684 116.498C80.6677 103.37 83.6376 90.2216 90.2743 78.8412C96.9109 67.4607 106.892 58.4008 118.86 52.8937C130.828 47.3867 144.202 45.6998 157.162 48.0626L145.663 111.141H209.781Z",
    fill: "#9747FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.781,
    cy: 167.627,
    r: 98.4675,
    fill: "#44AFEC",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.781 69.1596C358.256 69.1596 377.294 74.9347 393.487 85.7544C409.679 96.5742 422.3 111.953 429.753 129.945C437.206 147.938 439.156 167.736 435.356 186.837C431.557 205.938 422.179 223.483 408.408 237.254L338.781 167.627L338.781 69.1596Z",
    fill: "#56CCF2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 388C24 385.791 25.7909 384 28 384H78C80.2091 384 82 385.791 82 388V507H24V388Z",
    fill: "#2D9CDB",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101 424C101 421.791 102.791 420 105 420H157C159.209 420 161 421.791 161 424V507H101V424Z",
    fill: "#2D9CDB",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182 411C182 408.791 183.791 407 186 407H238C240.209 407 242 408.791 242 411V507H182V411Z",
    fill: "#2D9CDB",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260 313C260 310.791 261.791 309 264 309H316C318.209 309 320 310.791 320 313V507H260V313Z",
    fill: "#2D9CDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M341 397C341 394.791 342.791 393 345 393H397C399.209 393 401 394.791 401 397V507H341V397Z",
    fill: "#2D9CDB",
    fillOpacity: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420 401C420 398.791 421.791 397 424 397H474C476.209 397 478 398.791 478 401V507H420V401Z",
    fill: "#2D9CDB",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicsAndTables);
export default __webpack_public_path__ + "static/media/graphics-and-tables.ca901598a8954ffba8db7fcd7d56c592.svg";
export { ForwardRef as ReactComponent };